import {Shift} from '@app/core/models/shift.model';
import {User} from '@app/core/models/user.model';
import {extendMoment} from 'moment-range';
import {RDate} from '@app/core/models/rDate.model';
import * as _moment from 'moment';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

const moment = extendMoment(_moment);

export class Availability extends BaseModel {
	public id: number;
	public start: RDate;
	public end: RDate;
	public reason: string;
	public status: number;
	public user: User;
	public shifts_in_period: Shift[] = [];
	public loading: boolean = false;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public daysInRange(): any {
		return Array.from(moment().range(this.start.UTCDate, this.end.UTCDate).by('days'));
	}

	public deserialize(input: any): any {
		Object.assign(this, input);
		this.shifts_in_period = [];
		if (input.user) {
			this.user = new User(this.tenantTZ, this.interService).deserialize(input.user);
		}
		if (input.start) {
			this.start = new RDate(this.tenantTZ, this.interService).deserialize(input.start);
		}
		if (input.end) {
			this.end = new RDate(this.tenantTZ, this.interService).deserialize(input.end);
		}
		if (input.shifts_in_period) {
			this.shifts_in_period = input.shifts_in_period.map(shift => new Shift(this.tenantTZ, this.interService).deserialize(shift));
		}

		return this;
	}
}
